import {Component} from '@angular/core';
import {IonicPage, NavController} from 'ionic-angular';

import {ProofBeforeBeginPage} from '../proof-before-begin/proof-before-begin';

import {AlertProvider} from '../../providers/alert/alert';
import {MediaProvider} from '../../providers/media/media';

import {Geolocation} from '@ionic-native/geolocation';
import {NativeGeocoder, NativeGeocoderOptions, NativeGeocoderReverseResult} from '@ionic-native/native-geocoder';

import {HttpClient} from '@angular/common/http';
import * as Config from "../../app/app.config";

/**
 * Generated class for the IdentificationCheckOnAppPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-identification-check-on-app',
  templateUrl: 'identification-check-on-app.html',
})
export class IdentificationCheckOnAppPage {

  selfieColor: string = 'danger';
  frontIdentificationColor: string = 'danger';
  backIdentificationColor: string = 'danger';
  movieColor: string = 'danger';
  userLocation;
  userIp;

  constructor(
    private navCtrl: NavController,
    private alert: AlertProvider,
    private alertProvider: AlertProvider,
    private mediaProvider: MediaProvider,
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    private http: HttpClient,
  ) {
    // console.log('constructor');
    // console.log('selfieColor: ' + this.selfieColor);
    // console.log('frontIdentificationColor: ' + this.frontIdentificationColor);
    // console.log('backIdentificationColor: ' + this.backIdentificationColor);
    // console.log('movieColor: ' + this.movieColor);
    this.getPosition();
    this.getIp();
    this.takeAudio();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad IdentificationCheckOnAppPage');
  }

  getIp() {
    this.http.get(Config.urlIp).subscribe((response) => {
      console.log(response);
      if (response) {
        this.userIp = response['origin'];
      }
    });
  }

  getPosition() {
    this.geolocation.getCurrentPosition().then((resp) => {
      let options: NativeGeocoderOptions = {
        useLocale: true,
        maxResults: 1
      };

      this.nativeGeocoder.reverseGeocode(resp.coords.latitude, resp.coords.longitude, options)
        .then((result: NativeGeocoderReverseResult[]) => {
          this.userLocation = result[0];
        }).catch((error: any) => console.log(error));
    }).catch((error) => {
      console.log('Error getting location', error);
    });
  }

  doContinue() {
    // console.log('doContinue');
    // console.log('selfieColor: ' + this.selfieColor);
    // console.log('frontIdentificationColor: ' + this.frontIdentificationColor);
    // console.log('backIdentificationColor: ' + this.backIdentificationColor);
    // console.log('movieColor: ' + this.movieColor);

    let valid = true;
    valid = (valid) && (this.selfieColor !== 'danger');
    valid = (valid) && (this.frontIdentificationColor !== 'danger');
    valid = (valid) && (this.backIdentificationColor !== 'danger');
    valid = (valid) && (this.movieColor !== 'danger');

    if (valid) {
      this.navCtrl.push(ProofBeforeBeginPage);
    } else {
      this.alert.doAlert('Existem informações a serem fornecidas.');
    }
  }

  takeSelfie() {
    if (this.selfieColor === 'danger') {
      let that = this;

      this.mediaProvider.takeSelfie().then((selfie) => {
        that.selfieColor = (selfie !== null) ?
          'primary' : 'danger';

        // console.log('takeSelfie');
        // console.log(selfie);
        // console.log('selfieColor: ' + that.selfieColor);
      });
    }
  }

  takeFrontIdentification() {
    if (this.frontIdentificationColor === 'danger') {
      let that = this;

      this.mediaProvider.takeFrontIdentification().then((frontIdentification) => {
        that.frontIdentificationColor = (frontIdentification !== null) ?
          'primary' : 'danger';

        // console.log('takeFrontIdentification');
        // console.log(frontIdentification);
        // console.log('frontIdentificationColor: ' + that.frontIdentificationColor);
      });
    }
  }

  takeBackIdentification() {
    if (this.backIdentificationColor === 'danger') {
      let that = this;

      this.mediaProvider.takeBackIdentification().then((backIdentification) => {
        that.backIdentificationColor = (backIdentification !== null) ?
          'primary' : 'danger';

        // console.log('takeBackIdentification');
        // console.log(backIdentification);
        // console.log('backIdentificationColor: ' + that.backIdentificationColor);
      });
    }
  }

  takeAudio() {
    this.mediaProvider.takeAudio(null, null, null);
    console.log('Chamei takeAudio em mediaProvider');
  }

  takeMovie() {
    if (this.movieColor === 'danger') {
      let that = this;
      let message = 'Você deve fazer uma filmagem rápida do local onde você está executando a prova, considerando todo o ambiente e também a sua imagem.';

      this.alertProvider.doAlert(message, 'Informe', () => {
        this.mediaProvider.takeMovie().then((movie) => {
          that.movieColor = (movie !== null) ?
            'primary' : 'danger';

          // console.log('takeMovie');
          // console.log(movie);
          // console.log('movieColor: ' + that.movieColor);
        });
      }, 'Prosseguir');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/identification-check-on-app/identification-check-on-app.ts